import { render, staticRenderFns } from "./newProject2.vue?vue&type=template&id=1d68a1f4&scoped=true"
import script from "./newProject2.vue?vue&type=script&lang=js"
export * from "./newProject2.vue?vue&type=script&lang=js"
import style0 from "./newProject2.vue?vue&type=style&index=0&id=1d68a1f4&prod&scoped=true&lang=css"
import style1 from "./newProject2.vue?vue&type=style&index=1&id=1d68a1f4&prod&lang=css"
import style2 from "./newProject2.vue?vue&type=style&index=2&id=1d68a1f4&prod&scoped=true&lang=scss"
import style3 from "./newProject2.vue?vue&type=style&index=3&id=1d68a1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68a1f4",
  null
  
)

export default component.exports